module.exports = __webpack_public_path__ + "img/combat-shop.138daeea.png";